import { createApi, createStore } from 'effector';

export const drawerState$ = createStore(false);
export const drawer = createApi(drawerState$, {
	open: () => true,
	close: () => false,
	toggle: (state) => !state,
});
